<template>
  <span v-if="isVisible" :class="badgeClasses">
    <slot />
  </span>
</template>

<script src="./badge.component.ts" lang="ts" />
